<template>
  <div class="chapter-bar">
    <BaseBar
      :class="
        disabledChapter ? 'chapter-bar__title--unselected bg-light' : null
      "
      class="chapter-bar__title"
      @click.native="emitSurveyLevel"
    >
      <div class="chapter-bar-title__title d-inline-flex items-center">
        <span class="text-ternary">{{ suffixTitle }}</span>
        <span class="text-ternary px-3">-</span>{{ chapter.name }}
      </div>
      <EntityBarProgress
        :current-question-ids="currentQuestionIds"
        :class="disabledChapter ? 'text-primary' : 'text-white'"
        class="chapter-bar-title__progress"
      />
    </BaseBar>

    <ExpandBarButton
      v-show="!chapterSelection && !disabledChapter"
      class="chapter-bar__btn"
      :open="showDirectChildren"
      type="chapter"
      @click="expand()"
    />
    <SelectChapterButton
      v-show="chapterSelection"
      class="chapter-bar__btn"
      :selected="chapter.selected"
      @click="selectChapter"
    />

    <div class="chapter-bar__content d-flex flex-column align-content-end">
      <SectionBar
        v-for="[sectionKey, section] of sections"
        :key="getSectionKey(sectionKey)"
        :section="section"
        :show="showSections"
        @clicked="emitSectionClick"
      />
    </div>
  </div>
</template>

<script>
import BaseBar from './BaseBar.vue'
import SectionBar from './SectionBar.vue'
import ExpandBarButton from './ExpandBarButton.vue'
import EntityBarProgress from './EntityBarProgress.vue'
import SelectChapterButton from './SelectChapterButton.vue'

export default {
  components: {
    BaseBar,
    SectionBar,
    ExpandBarButton,
    EntityBarProgress,
    SelectChapterButton,
  },
  props: {
    chapter: {
      type: Object,
      required: true,
    },
    chapterSelection: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showDirectChildren: false,
      chapterSurveyLevel: new Map([['chapterId', this.chapter.display_order]]),
      form: null,
    }
  },
  computed: {
    disabledChapter() {
      return !this.chapter.selected
    },
    sections() {
      return this.chapter.sections.reduce((sectionMap, section) => {
        return sectionMap.set(section.display_order, section)
      }, new Map())
    },
    suffixTitle() {
      return `Chapitre ${this.chapter.display_order}`
    },
    currentQuestionIds() {
      return this.chapter.question_ids ?? []
    },
    showSections() {
      return this.showDirectChildren && !this.chapterSelection
    },
  },
  methods: {
    getSectionKey(sectionKey) {
      return `section-${this.chapter.id}-${sectionKey}`
    },
    emitSurveyLevel() {
      if (!this.chapterSelection) {
        if (!this.disabledChapter) {
          this.$emit('clicked', this.chapterSurveyLevel)
        }
      }
    },
    expand() {
      if (!this.chapterSelection && !this.disabledChapter) {
        this.showDirectChildren = !this.showDirectChildren
      }
    },
    emitSectionClick(sectionSurveyLevel) {
      const surveyLevel = new Map(
        [...this.chapterSurveyLevel].concat([...sectionSurveyLevel])
      )

      this.$emit('clicked', surveyLevel)
    },
    selectChapter() {
      this.$emit('selectChapter')
    },
  },
}
</script>
<style lang="scss">
.chapter-bar {
  display: grid;
  grid-template-columns: auto 3em;
  grid-template-rows: max-content;
  grid-template-areas: 'title btn' 'content content';
  &__title {
    transition: background-color 0.3s ease-in-out, color 0.2s ease-in-out 0.15s;
    cursor: pointer;
    padding: 2rem 3rem !important;
    grid-area: title;
    font-size: 1.5rem;
    line-height: 1em;
    font-weight: 400;
    text-transform: uppercase;
    letter-spacing: 0.141rem;
    display: flex;
    justify-content: space-between;
    &--unselected {
      cursor: default;
      color: var(--gdep_color__primary-dark) !important;
      border: solid 1px var(--gdep_color__primary-dark);
      background-color: var(-bs-gray-100);
    }
  }
  &__btn {
    grid-area: btn;
  }
  &__content {
    width: 90%;
    place-self: end;
    grid-area: content;
  }
  .chapter-bar-title__progress {
    transition: color 0.2s ease-in-out 0.15s;
  }
}
</style>
